/**
 * Membership type enum — hard-coded values agreed with backend.
 * These values are used as-is on both frontend and backend wire format.
 */
export enum MembershipType {
  InHouse = 'IN_HOUSE',
  Partner = 'PARTNER',
  Contractor = 'CONTRACTOR',
}
